<template>
  <div class="doctor-profile__comment-group">
    <div class="doctor-profile__header">
      <img src="./../assets/images/comments-icon.svg" alt="" />
      <h4 class="doctor-profile__title">
        Comentários
        <span>(108 Avaliações)</span>
      </h4>
      <span class="doctor-profile__line" />
    </div>

    <div class="doctor-profile__comment-items">
      <div class="doctor-profile__comment-header">
        <h4 class="doctor-profile__comment-title">
          {{ testimonial.patient_name }}
        </h4>
        <div class="doctor-profile__rating">
          <img
            src="./../assets/images/star-icon.svg"
            alt="Pontuação do profissional de saúde"
          />
          <span class="doctor-profile__number">4.0</span>
        </div>
        <span class="doctor-profile__comment-date">Jul de 2020</span>
      </div>
      <div class="doctor-profile__comment-box">
        <p class="doctor-profile__comment">
          {{ testimonial.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Testimonial",
  props: { testimonial: { type: Object, default: null } }
};
</script>
